/**
 * Created by brunopoeta on 19/06/17.
 */

const config = require('../../../../scripts/partials/config');

export default class CalendarController {

    constructor($http) {
        this.campi = {};
        this.colors = ['green', 'yellow', 'red', 'blue', 'black'];
        this.days = Array;
        this.events = {};
	this.eventsFull = {};
        this.fetched = null;

        let currentDate = new Date();
        this.options = {
            campus: '',
            month: currentDate.getMonth() + 1,
            type: '',
            view: 'month',
            year: currentDate.getFullYear()
        };
        this.status = '';
        this.summary = {};

        this.toolbar = {
            fullWidth: true,
            id: 'calendar-toolbar',
            filters: [
                {
                    // callback: this.fetch.bind(this),
                    items: [
                        {
                            id: null,
                            title: 'Todos os tipos'
                        }
                    ],
                    label: 'Tipo',
                    selected: null
                },
                {
                    // callback: this.fetch.bind(this),
                    items: [
                        {
                            id: null,
                            title: 'Todos os campus'
                        }
                    ],
                    label: 'Campus',
                    selected: null
                }
            ],
            padded: true,
            search: {
                callback: this.search.bind(this),
                placeholder: 'Digite aqui sua busca',
                query: ''
            },
            shadow: true
        };

        // Defining services
        this.$http = $http;

        // Running functions
	this.update_urls();
        this.getDaysInMonth();
        this.getMonth();
        this.fetch();
    }

    update_urls() {
	const base = config.calendarAjax + "?action=download_events_archive_ics";
	this.export_year = base + "&year=" + this.options.year + "&month=";
	this.export_month = this.export_year + this.options.month;
    }

    changeMonth(context) {
        this.options.month = (context === 'add') ? (this.options.month + 1 > 12 ? 1 : this.options.month + 1) : (!(this.options.month - 1) ? 12 : this.options.month - 1);
        this.options.year = (context === 'add') ? (this.options.month === 1 ? this.options.year + 1 : this.options.year) : (this.options.month === 12 ? this.options.year - 1 : this.options.year)
	
	this.update_urls();
        this.getDaysInMonth();
        this.fetch();
    }

    changeView(view) {
        this.options.view = view;

        if (view === 'summary') {
            this.fetchSummary();
        }
    }

    convertEvents(data) {
        const events = data.events;
        const month = parseInt(data.month);
        const year = parseInt(data.year);

        this.events[`${month}-${year}`] = {
            all: []
        };

	this.eventsFull[`${month}-${year}`] = {};

        events.forEach((event) => {
            if (!this.events[`${month}-${year}`][parseInt(event.date.start.day)]) {
                this.events[`${month}-${year}`][parseInt(event.date.start.day)] = [];
            }

            this.events[`${month}-${year}`][parseInt(event.date.start.day)].push(event);
            this.events[`${month}-${year}`].all.push(event);

	    if (event.date.start.day == event.date.finish.day) {
		if (!this.eventsFull[`${month}-${year}`][parseInt(event.date.start.day)]) {
                    this.eventsFull[`${month}-${year}`][parseInt(event.date.start.day)] = [];
		}

		this.eventsFull[`${month}-${year}`][parseInt(event.date.start.day)].push(event);
	    } else {
		for(let i = parseInt(event.date.start.day); i <= parseInt(event.date.finish.day); i++) {
		    if (!this.eventsFull[`${month}-${year}`][i]) {
			this.eventsFull[`${month}-${year}`][i] = [];
		    }

		    this.eventsFull[`${month}-${year}`][i].push(event);
		}
	    }
        });

        //console.log(this.events[`${month}-${year}`].all);
    }

    convertFilters(data) {
        angular.forEach(data.campi, (campus) => {
            this
                .toolbar
                .filters[1]
                .items
                .push({
                    id: parseInt(campus.id),
                    title: campus.name
                });
        });

        angular.forEach(data.types, (type) => {
            this
                .toolbar
                .filters[0]
                .items
                .push({
                    id: parseInt(type.id),
                    title: type.type
                });
        });
    }

    convertCampus(campi) {
        angular.forEach(campi, (campus) => {
            this.campi[`${campus.id}`] = {
                color: campus.color,
                name: campus.name
            };
        });

        this.campi[5] = {
            color: 'black',
            name: 'Mais de um campus'
        };
        console.log(this.campi);
    }

    fetch() {
        if (this.events[`${this.options.month}-${this.options.year}`]) {
            return false;
        }

        this.status = 'fetching';

        this
            .$http({
                url: config.calendar,
                method: 'GET',
                params: {
                    month: this.options.month,
                    year: this.options.year
                }
            })
            .then((res, err) => {
                if (!err) {
                    this.status = '';

                    //console.log(res.data);

                    this.convertEvents(res.data);

                    if (!this.options.fetched) {
                        this.convertFilters(res.data);
                        this.convertCampus(res.data.campi);
                    }

                    this.options.fetched = true;
                } else {

                }
            });
    }

    fetchSummary() {
        if (this.summary.fetched) {
            return false;
        }

        const year = new Date().getFullYear();

        this.status = 'fetching';

        this
            .$http({
                url: config.calendar,
                method: 'GET',
                params: {
                    summary: true,
                    year: year
                }
            })
            .then((res, err) => {
                if (!err) {
                    this.status = '';

                    this.summary = {
                        events: res.data.events,
                        fetched: true,
                        year: year,
                    };

                    console.log('summary');
                    console.log(res);
                } else {

                }
            });
    }

    getAdjacentMonthDays(context) {
        const days = [];
        const firstDay = this.parseDate(`${this.options.year}-${this.options.month}-1 12:00:00`).getDay() - 1;
        const lastDay = this.parseDate(`${this.options.year}-${this.options.month}-${this.getDaysInMonth(this.options.month)} 12:00:00`).getDay();

        let month;
        let daysInMonth;

        if (context === 'previous') {
            if (!(this.options.month - 1)) {
                month = 12;
            } else {
                month = this.options.month - 1;
            }
        } else {
            if (this.options.month + 1 > 12) {
                month = 1;
            } else {
                month = this.options.month + 1;
            }
        }

        daysInMonth = this.getDaysInMonth(month);

        if (context === 'previous') {
            for (let i = daysInMonth - firstDay; i <= daysInMonth; i++) {
                days.push(i);
            }
        } else {
            for (let i = 1; i <= (6 - lastDay); i++) {
                days.push(i);
            }
        }

        return days;
    }

    getDaysInMonth(month) {
        const days = [31, (this.isLeapYear() ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        if (month) {
            return days[month - 1];
        } else {
            this
                .options
                .totalDays = days[this.options.month - 1];
        }
    }

    getDayEvents(day) {
        if (!this.events[`${this.options.month}-${this.options.year}`]) {
            return false;
        }
        return this.events[`${this.options.month}-${this.options.year}`][day];
    }

    getDayEventsFull(day) {
        if (!this.eventsFull[`${this.options.month}-${this.options.year}`]) {
            return false;
        }
        return this.eventsFull[`${this.options.month}-${this.options.year}`][day];
    }

    getEventDate(event, context) {
        const date = event.date[context];

        if (date) {
            return `${date.day}/${date.month}/${this.summary.year}`;
        } else {
            return null;
        }
    }

    getMonth(month) {
        const months = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

        return (month > 12) ? months[0] : (!month) ? months[11] : months[month - 1];
    }

    getMonthEvents() {
        if (!this.events[`${this.options.month}-${this.options.year}`]) {
            return false;
        }
        return this.events[`${this.options.month}-${this.options.year}`].all;
    }

    getSemesterEvents(semester) {
        const events = [];

        angular.forEach(this.summary.events, (event) => {
            if (semester === 1) {

                if (+event.date.start.month < 7) {
                    events.push(event);
                }

            } else {
                if (+event.date.start.month > 6) {
                    events.push(event);
                }
            }
        });

        return events;
    }

    getWeekDay(day, context, month, year) {
        const y = year || this.options.year;
        const m = (month || this.options.month) - 1;
        const days = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
        const date = new Date(y, m, day, 0, 0, 0, 0);

        return (context === 'abbr') ? days[date.getDay()].substr(0, 3) : days[date.getDay()];
    }

    getYear(month, year) {
        return (month > 12) ? year + 1 : (!month) ? year - 1 : year;
    }

    isLeapYear() {
        return new Date(this.options.year, 1, 29).getDate() === 29;
    }

    parseDate(str) {
        const d = str.split(/\D+/g).map(function (v) {
            return parseInt(v, 10);
        });

        return new Date(d[0], d[1] - 1, d[2], d[3], d[4], d[5]);
    }

    resetSearch() {
        this.toolbar.search.active = false;
        this.toolbar.search.query = '';
        this.toolbar.search.results = [];
    }

    search() {

        if (!this.toolbar.search.query) {
            this.resetSearch();
            return false;
        }

        this.toolbar.search.active = true;
        this.toolbar.search.results = [];
        this.status = 'fetching';

        this
            .$http({
                url: config.calendar,
                method: 'GET',
                params: {
                    query: this.toolbar.search.query
                }
            })
            .then((res, err) => {
                if (!err) {
                    this.status = '';

                    console.log(res);

                    if (res.data.events) {
                        this.toolbar.search.results = res.data.events;
                    }

                    /*this.convertEvents(res.data);

                     if (!this.options.fetched) {
                     this.convertFilters(res.data);
                     this.convertCampus(res.data.campi);
                     }*/

                    // this.options.fetched = true;
                } else {

                }
            });
    }
}
